<template>
  <div class="modal fade" id="questionResponseModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 v-if="!editing" class="modal-title">New Question Response</h5>
          <h5 v-if="editing" class="modal-title">Edit Question Response</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="saveQuestionResponse">
            <div class="form-group">
              <label for="question">Question Example</label>
              <input
                type="text"
                class="form-control"
                id="question"
                placeholder="Question Example"
                required
                v-model="question"
              />
            </div>
            <div class="form-group">
              <label for="response">{{ responseCategoryName }} Response</label>
              <button
                type="button"
                class="btn btn-sm btn-link float-right"
                v-on:click="addBlank"
              >
                Add Blank
              </button>
              <textarea
                class="form-control"
                id="response"
                rows="6"
                placeholder="Response"
                required
                v-model="response"
              >
              </textarea>
            </div>
            <p class="text-secondary">
              {{ response.length }} / 8000 characters
            </p>

            <div class="text-right">
              <button v-if="editing" class="btn btn-primary">
                Update Question Response
              </button>
              <button v-if="!editing" type="submit" class="btn btn-primary">
                Create Question Response
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "QuestionResponseModal",
  props: {
    Response: Object,
    ResponseCategoryId: String,
    ResponseCategoryName: String
  },
  data() {
    return {
      question: "",
      response: "",
      editingResponse: null,
      editing: false,
      responseCategoryId: "",
      responseCategoryName: ""
    };
  },
  watch: {
    Response: function() {
      if (this.Response != null) {
        this.response = this.Response.Response.replace(
          /[@]blank-\d+[@]/g,
          "@__________@"
        );
        this.question = this.Response.Question;
        this.editingResponse = this.Response;
        this.editing = true;
      } else {
        this.clearFields();
        this.editing = false;
      }
    },
    ResponseCategoryId: function() {
      this.responseCategoryId = this.ResponseCategoryId;
    },
    ResponseCategoryName: function() {
      this.responseCategoryName = this.ResponseCategoryName;
    }
  },
  mounted() {
    var view = this;
    $("#questionResponseModal").on("hidden.bs.modal", function() {
      if (view.editing) {
        view.$emit("editClosed");
      }
    });
    $("#questionResponseModal").on("shown.bs.modal", function() {
      $("#question").focus();
    });
  },
  methods: {
    async saveQuestionResponse() {
      this.response = this.createDatabaseResponseString(this.response);
      if (this.editing) {
        await this.editQuestionResponse();
      } else {
        await this.createQuestionResponse();
      }
    },
    createDatabaseResponseString(responseWithBlanks) {
      var matches = responseWithBlanks.match(/[@]_+[@](?:hint:[^@]+[@])?/g);
      for (let i = 1; i < matches.length + 1; i++) {
        responseWithBlanks = responseWithBlanks.replace(
          /[@]_+[@]/,
          "@blank-" + i + "@"
        );
      }
      return responseWithBlanks;
    },
    async createQuestionResponse() {
      var view = this;
      $("#questionResponseModal").modal("hide");
      view.$store.commit("updateLoading", true);
      var responseToCreate = {
        Question: view.$data.question,
        Response: view.$data.response,
        Application_Template_Response_Category_Id: view.$data.responseCategoryId
      };
      await this.$createApplicationTemplateResponse(responseToCreate)
        .then(newResponse => {
          view.$emit("addedResponse", newResponse);
          view.$store.commit("updateLoading", false);
          view.clearFields();
        })
        .catch(e => {
          console.log(e);
          $("#questionResponseModal").modal("show");
          view.$store.commit("updateLoading", false);
        });
    },
    async editQuestionResponse() {
      var view = this;
      $("#questionResponseModal").modal("hide");
      view.$store.commit("updateLoading", true);
      var responseToUpdate = {
        Application_Template_Response_Id:
          view.$data.editingResponse.Application_Template_Response_Id,
        Question: view.$data.question,
        Response: view.$data.response,
        Application_Template_Response_Category_Id: view.$data.responseCategoryId
      };
      await this.$updateApplicationTemplateResponse(responseToUpdate)
        .then(editedResponse => {
          view.$emit("editedResponse", editedResponse);
          view.$store.commit("updateLoading", false);
          view.clearFields();
        })
        .catch(e => {
          console.log(e);
          $("#questionResponseModal").modal("show");
          view.$store.commit("updateLoading", false);
        });
    },
    clearFields() {
      this.question = "";
      this.response = "";
      this.editingResponse = null;
    },
    addBlank() {
      this.response = this.response.concat("@__________@hint:@");
      $("#response").focus();
    }
  }
};
</script>
